import { Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import { Button, Header } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import * as Yup from 'yup';
import TextInputMuiFormik from "../../app/common/form/muiFormikComponents/TextInputMuiFormik";


export default observer(function MailRegisterForm() {
    const { modalStore, translationStore : t } = useStore();
    const sendMail = (email: string) => {
        const mailto = "a.baumgart@haw-hamburg.de";
        const subject = "Cokomo - Registrierungs Anfrage von ";
        const body = "Dies ist eine automatisch verfasste Email von Cokomo";
        const mailtoLink = `mailto:${mailto}?subject=${encodeURIComponent(subject + email)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
        modalStore.closeModal();
    };

    return (
        <Formik
            initialValues={{ email: ''}}
            onSubmit={(values) => sendMail(values.email)}
            validationSchema={Yup.object({
                email: Yup.string().email().required(),
            })}
        >
            <Form className='ui form' autoComplete='off'>
                <Header as='h2' content='Ein Konto erstellen lassen' color="teal" textAlign="center" />
                <TextInputMuiFormik label={t.i18n?.email} name='email' />
                <Button 
                    positive 
                    type="submit" 
                    fluid>
                        Absenden
                </Button>
            </Form>
        </Formik>
    )
})